import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DevicePhotoService } from 'src/app/components/devices-components/device-photo-gallery-card/device-photo.service';
import { DevicePhotoZoomDialogComponent } from 'src/app/components/devices-components/device-photo-zoom-dialog/device-photo-zoom-dialog.component';

@Component({
  selector: 'app-device-photo-gallery-card',
  templateUrl: './device-photo-gallery-card.component.html',
  styleUrls: ['./device-photo-gallery-card.component.scss']
})
export class DevicePhotoGalleryCardComponent implements OnInit {

  gallery = [{ name: 'asd', url: 'https://i.pinimg.com/originals/e1/73/83/e173833ed03121f9f0e2d22339d56d6e.jpg'},
             { name: 'asd', url: 'https://pbs.twimg.com/profile_images/683842208500285440/-kb4Pf8k_400x400.jpg'},
             { name: 'asd', url: 'https://i.pinimg.com/originals/e1/73/83/e173833ed03121f9f0e2d22339d56d6e.jpg'},
             { name: 'asd', url: 'https://pbs.twimg.com/profile_images/683842208500285440/-kb4Pf8k_400x400.jpg'},
             { name: 'asd', url: 'https://i.pinimg.com/originals/e1/73/83/e173833ed03121f9f0e2d22339d56d6e.jpg'},
             { name: 'asd', url: 'https://pbs.twimg.com/profile_images/683842208500285440/-kb4Pf8k_400x400.jpg'},
             { name: 'asd', url: 'https://i.pinimg.com/originals/e1/73/83/e173833ed03121f9f0e2d22339d56d6e.jpg'},
             { name: 'asd', url: 'https://pbs.twimg.com/profile_images/683842208500285440/-kb4Pf8k_400x400.jpg'},
             { name: 'asd', url: 'https://i.pinimg.com/originals/e1/73/83/e173833ed03121f9f0e2d22339d56d6e.jpg'},
             { name: 'asd', url: 'https://pbs.twimg.com/profile_images/683842208500285440/-kb4Pf8k_400x400.jpg'},
             { name: 'asd', url: 'https://i.pinimg.com/originals/e1/73/83/e173833ed03121f9f0e2d22339d56d6e.jpg'}];
  @ViewChild('wrapcarousel', { static: false }) wrapcarousel: ElementRef;
  @ViewChild('itemcarousel', { static: false }) itemcarousel: ElementRef;
  public horizontalScrollValue: number;

  constructor(public dialog: MatDialog,
              private devicePhotoService: DevicePhotoService  ) {  }

  // tslint:disable-next-line:no-empty
  ngOnInit() {
    this.horizontalScrollValue = 0;
  }
  public openRegisterDialog(url) {
    this.devicePhotoService.setPhotoURL(url).subscribe(
      (result) => {
        if (result) {
          const dialogref = this.dialog.open(DevicePhotoZoomDialogComponent);
        }
      }
    );
  }

  public removeItem(i) {
    this.gallery.splice(i, 1);
  }
  public moveLeft() {
    if (this.horizontalScrollValue < 0) {
      this.horizontalScrollValue += this.itemcarousel.nativeElement.getBoundingClientRect().width * 1;
    }
  }
  public moveRight() {
    if (this.horizontalScrollValue >= (this.wrapcarousel.nativeElement.scrollWidth - this.wrapcarousel.nativeElement.getBoundingClientRect().width) * (-1)) {
      this.horizontalScrollValue -= this.itemcarousel.nativeElement.getBoundingClientRect().width * 1;
    }
  }
  public horizontalScroll() {
    return {
      transform: 'translateX(' + this.horizontalScrollValue + 'px)'
    };
  }

}
